const redirectToHome = err => {
  if (err.response.status === 401) {
    const url = window.env === 'production' ? '/install' : '/bunnings/install'; // move to redux router
    window.location = url;
  }
};

export default redirectToHome;
